import { Datagrid, TextField, DateField, ReferenceManyField, BooleanField } from 'react-admin';

export const MachineBoardsList = () => (
  <ReferenceManyField reference="boards" target="machineId" label={false}>
    <Datagrid bulkActionButtons={false} rowClick={false}>
      <TextField source="boardType.name" label="Board Type" />
      <DateField source="updatedAt" showTime />
      <BooleanField source="active" label="Active" />
    </Datagrid>
  </ReferenceManyField>
);
